module.exports = __webpack_public_path__ + "static/img/prize_show.b287e5d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1314/prize_show.png
// module id = 477
// module chunks = 1